import Utils from "../../../utility";

const initialState = {
  userlist: [],
  propertyOwner: [],
  brands: [],
  order: "DESC",
  sortField: "addDate",
  offset: 1,
  take: 20,
  search: "",
  userType: "",
  count: 0,
};
export const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.USER_LIST}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_USER_LIST}`:
      return {
        ...initialState,
      };
    default:
      return { ...state };
  }
};
